export default {
  baseUrl: process.env.VUE_APP_API_BASE_URL || '',
  remoteControlBaseUrl: process.env.VUE_APP_REMOTE_BASE_URL || '',
  currentPortalRegion: process.env.VUE_APP_CURRENT_PORTAL_REGION,
  alternatePortalRegion: process.env.VUE_APP_ALT_PORTAL_REGION,
  alternatePortalRegionUrl: process.env.VUE_APP_ALT_PORTAL_REGION_URL,
};
